<template>
  <div class="quick-add-item no-print">
    <div class="quick-add-container" :class="{ 'loading': isLoading }">
      <input
        v-model="inputValue"
        :placeholder="`Add item... (e.g. 'Socks (7x)')`"
        class="quick-add-input"
        :data-group="groupName"
        :disabled="isLoading"
        @keyup.enter="handleAddAndStay"
        @blur="handleAdd"
      />
      <div class="quick-add-icon">
        <v-progress-circular
          v-if="isLoading"
          size="16"
          width="2"
          color="primary"
          indeterminate
        />
        <v-icon v-else size="small" color="grey">mdi-plus</v-icon>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, watch } from 'vue'

export default {
  name: 'QuickAddItem',
  props: {
    groupName: {
      type: String,
      required: true
    },
    modelValue: {
      type: String,
      default: ''
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['update:modelValue', 'add', 'addAndStay'],
  setup(props, { emit }) {
    const inputValue = ref(props.modelValue)

    watch(() => props.modelValue, (newValue) => {
      inputValue.value = newValue
    })

    watch(inputValue, (newValue) => {
      emit('update:modelValue', newValue)
    })

    const handleAdd = () => {
      if (inputValue.value.trim()) {
        emit('add', props.groupName)
      }
    }

    const handleAddAndStay = (event) => {
      if (inputValue.value.trim()) {
        emit('addAndStay', props.groupName, event)
      }
    }

    return {
      inputValue,
      handleAdd,
      handleAddAndStay
    }
  }
}
</script>

<style scoped>
/* Quick Add Item Styles */
.quick-add-item {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.quick-add-container {
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  border: 1px dashed #ddd;
  border-radius: 4px;
  background: white;
  transition: all 0.2s ease;
}

.quick-add-container:hover {
  border-color: #bbb;
  background: white;
}

.quick-add-container:focus-within {
  border-color: #1976d2;
  background: white;
}

.quick-add-icon {
  margin-left: 0.5rem;
  opacity: 0.6;
}

.quick-add-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 0.9rem;
  color: #333;
  padding: 0.25rem 0;
}

.quick-add-input::placeholder {
  color: #999;
  font-style: italic;
}

.quick-add-input:focus {
  color: #000;
}

.quick-add-container.loading {
  opacity: 0.7;
}

.quick-add-input:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

/* Compact sizing for 4-column layout */
.columns-4 .quick-add-container {
  padding: 0.15rem 0.4rem;
}

.columns-4 .quick-add-input {
  font-size: 0.8rem;
  padding: 0.15rem 0;
}

.columns-4 .quick-add-icon {
  margin-left: 0.3rem;
}
</style>